import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Table } from 'antd';
import * as Io5Icons from 'react-icons/io5';
import { NODE_BACKEND_API_URL } from '../../config';
import './variabletable.css';

function VariableTable({ lastUpdatedBrand }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [flashingBrand, setFlashingBrand] = useState(null);
    const flashTimeoutRef = useRef(null);

    // Helper function to fetch data from the API
    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${NODE_BACKEND_API_URL}/getbrandvariables/`);
            // Transform data to include key for ANT Design Table
            const transformedData = res.data
                .filter(item => item.BrandName !== 'DUTTO')
                .map(item => ({
                    ...item,
                    key: item.BrandName, // ANT Design Table requires unique key
                }));
            setData(transformedData);
        } catch (er) {
            console.error("Error fetching variable data:", er);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    // Effect hook to fetch data on component mount and when lastUpdatedBrand changes
    useEffect(() => {
        fetchData();
    }, [lastUpdatedBrand]);

    // Effect hook for handling the flashing animation
    useEffect(() => {
        if (lastUpdatedBrand) {
            setFlashingBrand(lastUpdatedBrand);

            // Clear any existing timeout
            if (flashTimeoutRef.current) {
                clearTimeout(flashTimeoutRef.current);
            }

            // Set a new timeout to remove the flashing class after 3 seconds
            flashTimeoutRef.current = setTimeout(() => {
                setFlashingBrand(null);
                flashTimeoutRef.current = null;
            }, 3000);

            // Cleanup function
            return () => {
                if (flashTimeoutRef.current) {
                    clearTimeout(flashTimeoutRef.current);
                }
            };
        }
    }, [lastUpdatedBrand]);

    // Helper function to format the date
    const formatDate = (dateString) => {
        if (!dateString) return '';

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return 'Invalid Date';
        }

        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = date.getUTCFullYear();

        return `${day}/${month}/${year}`;
    };

    // Define ANT Design Table columns
    const columns = [
        {
            title: 'MARCA',
            dataIndex: 'BrandName',
            key: 'BrandName',
            sorter: (a, b) => a.BrandName.localeCompare(b.BrandName),
            defaultSortOrder: 'ascend',
            width: '25%',
        },
        {
            title: 'IVA',
            dataIndex: 'TaxFactor',
            key: 'TaxFactor',
            width: '15%',
            align: 'center',
        },
        {
            title: 'DESC.',
            dataIndex: 'DiscountFactor',
            key: 'DiscountFactor',
            width: '15%',
            align: 'center',
        },
        {
            title: 'GAN.',
            dataIndex: 'MarkupFactor',
            key: 'MarkupFactor',
            width: '15%',
            align: 'center',
        },
        {
            title: 'MODIFICACION',
            dataIndex: 'LastChangeDate',
            key: 'LastChangeDate',
            sorter: (a, b) => new Date(a.LastChangeDate) - new Date(b.LastChangeDate),
            render: (date) => formatDate(date),
            width: '30%',
            align: 'center',
        },
    ];

    return (
        <div id='divenv'>
            <Io5Icons.IoBarChartSharp size={42} />
            <h2>VARIABLES ACTUALES</h2>
            <div className="variable-table-div">
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={false}
                    size="small"
                    locale={{
                        emptyText: 'No hay datos de variables disponibles.'
                    }}
                    rowClassName={(record) =>
                        record.BrandName === flashingBrand ? 'ant-table-row-flashing' : ''
                    }
                />
            </div>
        </div>
    );
}

export default VariableTable;